import sliceCreator from '../../index.jsx';
import {UPDATE_SEASON} from '../../../constants/index.jsx';
const _updateSeasonAction = sliceCreator('UPDATE_SEASON', UPDATE_SEASON, 'put');

const { asyncAction: updateSeasonAction, reducer, clearData: clearUpdateSeasonAction } = _updateSeasonAction;

export default reducer;

export {
    updateSeasonAction,
    clearUpdateSeasonAction
}